import Support from "../components/pages/supports/Support";
const routes = [
    {
        path: "/support",
        element: <Support />
    }
];
export default routes;
